module.exports = __webpack_public_path__ + "static/abc_vector-eec6e6b0ea8fdd3914668c465301aa2b.png";